// src/core/lib/widget-status.ts
// وضعیت انتشار ویجت‌ها: 'publish' (نمایش در سایت) یا 'draft' (نمایش داده نمی‌شه).
export type WidgetStatus = 'publish' | 'draft';

export function isWidgetPublished(widget: unknown): boolean {
  return (widget as any)?.status !== 'draft';
}

/** فقط ویجت‌های منتشرشده رو نگه می‌داره (ترتیب حفظ می‌شه). */
export function filterPublishedWidgets<T>(widgets: T[]): T[] {
  return widgets.filter(isWidgetPublished);
}
